﻿export enum OrderDateType {
    Undefined = 0,
    Started = 1,
    Submitted = 2,
    ShipDate = 3
}